import { HhsgSharedClientContact } from './client-contact.model';
import { HhsgSharedClientAKA } from './client-aka.model';
import { HhsgSharedHuronContract } from './huron-contract.model';
import { HhsgSharedClientApplication } from './client-application.model';
import { HhsgSharedTrackingBase } from './tracking-base.model';

export class HhsgSharedClient extends HhsgSharedTrackingBase {

	constructor() {
		super();
		this.clientContactModels = [];
		this.clientAkaModels = [];
		this.clientHuronContractModels = [];
	}

	loginPageText: string;
	fullLogoPath: string;
	npiNumber: string;
	websiteUrl: string;	
	timeZoneId: string;
	removeExistingLogo: boolean;
	forceTLSWhenSendingEmail: boolean;
	
	isCorporation: boolean; // Only used during saving new client
	corporationId: number;
	corporationName: string;

	clientAkaModels: HhsgSharedClientAKA[];
	clientHuronContractModels: HhsgSharedHuronContract[];
	clientContactModels: HhsgSharedClientContact[];
	clientApplicationModels: HhsgSharedClientApplication[];

	// Address
	address1: string;
    address2: string;
    city: string;
    geoRegion: string;
	postalCode: string;	
	
	// Only Huron admins can edit these fields
	loginMethod: string;
	accountNumber: string;
	allowImpersonation: boolean;
	upsertStatus: boolean;

    LastModifiedBy: string;
}
